<template>
  <div class="flex flex-col industry al-input pt-2 px-2">
    <v-select name="user_group"
              class="border-none"
              v-model="selected"
              :options="industry_options" :clearable="false"></v-select>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import selectData from './data.json'
export default {
  name: 'CompanyIndustarySelect',
  props: {
    changed: {
      type: Function
    },
    selected_val: {
      type: String
    }
  },
  components: {
    vSelect
  },
  mounted () {
    if (this.selected_val) {
      const selected_opt = this.industry_options.filter(option => option.value === this.selected_val)
      if (selected_opt.length > 0) {
        this.selected = selected_opt
      } else {
        this.selected = this.industry_options[0]
      }
    }
  },
  data () {
    return {
      toggle: false,
      selected: '',
      search: '',
      industryData: selectData,
      industry_options2: [
        {
          label: 'Please Select',
          value: -1
        },
        {
          label: 'A/C, Refrigeration Repair',
          value: 0
        },
        {
          label: 'Accounting/Bookkeeping Services',
          value: 1
        },
        {
          label: 'Advertising Services',
          value: 2
        },
        {
          label: 'Agricultural Cooperative',
          value: 3
        },
        {
          label: 'Airlines, Air Carriers',
          value: 4
        },
        {
          label: 'Airports, Flying Fields',
          value: 5
        },
        {
          label: 'Ambulance Services',
          value: 6
        },
        {
          label: 'Amusement Parks/Carnivals',
          value: 7
        },
        {
          label: 'Antique Reproductions',
          value: 8
        },
        {
          label: 'Antique Shops',
          value: 9
        },
        {
          label: 'Aquariums',
          value: 10
        },
        {
          label: 'Architectural/Surveying Services',
          value: 11
        },
        {
          label: 'Art Dealers and Galleries',
          value: 12
        },
        {
          label: 'Artists Supply and Craft Shops',
          value: 13
        },
        {
          label: 'Auto Body Repair Shops',
          value: 14
        },
        {
          label: 'Auto Paint Shops',
          value: 15
        },
        {
          label: 'Auto Service Shops',
          value: 16
        },
        {
          label: 'Auto and Home Supply Stores',
          value: 17
        },
        {
          label: 'Automated Cash Disburse',
          value: 18
        },
        {
          label: 'Automated Fuel Dispensers',
          value: 19
        },
        {
          label: 'Automobile Associations',
          value: 20
        },
        {
          label: 'Automotive Parts and Accessories Stores',
          value: 21
        },
        {
          label: 'Automotive Tire Stores',
          value: 22
        },
        {
          label: 'Bail and Bond Payments (payment to the surety for the bond, not the actual bond paid to the government\n          agency)',
          value: 23
        },
        {
          label: 'Bakeries',
          value: 24
        },
        {
          label: 'Bands, Orcheslias',
          value: 25
        },
        {
          label: 'Barber and Beauty Shops',
          value: 26
        },
        {
          label: 'Betting/Casino Gambling',
          value: 27
        },
        {
          label: 'Bicycle Shops',
          value: 28
        },
        {
          label: 'Billiard/Pool Establishments',
          value: 29
        },
        {
          label: 'Boat Dealers',
          value: 30
        },
        {
          label: 'Boat Rentals and Leases',
          value: 31
        },
        {
          label: 'Book Stores',
          value: 32
        },
        {
          label: 'Books, Periodicals, and Newspapers',
          value: 33
        },
        {
          label: 'Bowling Alleys',
          value: 34
        },
        {
          label: 'Bus Lines',
          value: 35
        },
        {
          label: 'Business/Secretarial Schools',
          value: 36
        },
        {
          label: 'Buying/Shopping Services',
          value: 37
        },
        {
          label: 'Cable, Satellite, and Other Pay Television and Radio',
          value: 38
        },
        {
          label: 'Camera and Photographic Supply Stores',
          value: 39
        },
        {
          label: 'Candy, Nut, and Confectionery Stores',
          value: 40
        },
        {
          label: 'Car Rental Agencies',
          value: 41
        },
        {
          label: 'Car Washes',
          value: 42
        },
        {
          label: 'Car and liuck Dealers (New &amp; Used) Sales, Service, Repairs Parts and Leasing',
          value: 43
        },
        {
          label: 'Car and liuck Dealers (Used Only) Sales, Service, Repairs Parts and Leasing',
          value: 44
        },
        {
          label: 'Carpenliy Services',
          value: 45
        },
        {
          label: 'Carpet/Upholstery Cleaning',
          value: 46
        },
        {
          label: 'Caterers',
          value: 47
        },
        {
          label: 'Charitable and Social Service Organizations - Fundraising',
          value: 48
        },
        {
          label: 'Chemicals and Allied Products (Not Elsewhere Classified)',
          value: 49
        },
        {
          label: 'Child Care Services',
          value: 50
        },
        {
          label: 'Childrens and Infants Wear Stores',
          value: 51
        },
        {
          label: 'Chiropodists, Podialiists',
          value: 52
        },
        {
          label: 'Chiropractors',
          value: 53
        },
        {
          label: 'Cigar Stores and Stands',
          value: 54
        },
        {
          label: 'Civic, Social, Fraternal Associations',
          value: 55
        },
        {
          label: 'Cleaning and Maintenance',
          value: 56
        },
        {
          label: 'Clothing Rental',
          value: 57
        },
        {
          label: 'Colleges, Universities',
          value: 58
        },
        {
          label: 'Commercial Equipment (Not Elsewhere Classified)',
          value: 59
        },
        {
          label: 'Commercial Footwear',
          value: 60
        },
        {
          label: 'Commercial Photography, Art and Graphics',
          value: 61
        },
        {
          label: 'Commuter liansport, Ferries',
          value: 62
        },
        {
          label: 'Computer Network Services',
          value: 63
        },
        {
          label: 'Computer Programming',
          value: 64
        },
        {
          label: 'Computer Repair',
          value: 65
        },
        {
          label: 'Computer Software Stores',
          value: 66
        },
        {
          label: 'Computers, Peripherals, and Software',
          value: 67
        },
        {
          label: 'Concrete Work Services',
          value: 68
        },
        {
          label: 'Consliuction Materials (Not Elsewhere Classified)',
          value: 69
        },
        {
          label: 'Consulting, Public Relations',
          value: 70
        },
        {
          label: 'Correspondence Schools',
          value: 71
        },
        {
          label: 'Cosmetic Stores',
          value: 72
        },
        {
          label: 'Counseling Services',
          value: 73
        },
        {
          label: 'Counliy Clubs',
          value: 74
        },
        {
          label: 'Courier Services',
          value: 75
        },
        {
          label: 'Court Costs, Including Alimony and Child Support - Courts of Law',
          value: 76
        },
        {
          label: 'Credit Reporting Agencies',
          value: 77
        },
        {
          label: 'Cruise Lines',
          value: 78
        },
        {
          label: 'Dairy Products Stores',
          value: 79
        },
        {
          label: 'Dance Hall, Studios, Schools',
          value: 80
        },
        {
          label: 'Dating/Escort Services',
          value: 81
        },
        {
          label: 'Dentists, Orthodontists',
          value: 82
        },
        {
          label: 'Department Stores',
          value: 83
        },
        {
          label: 'Detective Agencies',
          value: 84
        },
        {
          label: 'Digital Goods Media – Books, Movies, Music',
          value: 85
        },
        {
          label: 'Digital Goods – Applications (Excludes Games)',
          value: 86
        },
        {
          label: 'Digital Goods – Games',
          value: 87
        },
        {
          label: 'Digital Goods – Large Digital Goods Merchant',
          value: 88
        },
        {
          label: 'Direct Marketing - Catalog Merchant',
          value: 89
        },
        {
          label: 'Direct Marketing - Combination Catalog and Retail Merchant',
          value: 90
        },
        {
          label: 'Direct Marketing - Inbound Telemarketing',
          value: 91
        },
        {
          label: 'Direct Marketing - Insurance Services',
          value: 92
        },
        {
          label: 'Direct Marketing - Other',
          value: 93
        },
        {
          label: 'Direct Marketing - Outbound Telemarketing',
          value: 94
        },
        {
          label: 'Direct Marketing - Subscription',
          value: 95
        },
        {
          label: 'Direct Marketing - liavel',
          value: 96
        },
        {
          label: 'Discount Stores',
          value: 97
        },
        {
          label: 'Doctors',
          value: 98
        },
        {
          label: 'Door-To-Door Sales',
          value: 99
        },
        {
          label: 'Drapery, Window Covering, and Upholstery Stores',
          value: 100
        },
        {
          label: 'Drinking Places',
          value: 101
        },
        {
          label: 'Drug Stores and Pharmacies',
          value: 102
        },
        {
          label: 'Drugs, Drug Proprietaries, and Druggist Sundries',
          value: 103
        },
        {
          label: 'Dry Cleaners',
          value: 104
        },
        {
          label: 'Durable Goods (Not Elsewhere Classified)',
          value: 105
        },
        {
          label: 'Duty Free Stores',
          value: 106
        },
        {
          label: 'Eating Places, Restaurants',
          value: 107
        },
        {
          label: 'Educational Services',
          value: 108
        },
        {
          label: 'Elecliic Razor Stores',
          value: 109
        },
        {
          label: 'Elecliical Parts and Equipment',
          value: 110
        },
        {
          label: 'Elecliical Services',
          value: 111
        },
        {
          label: 'Eleclionics Repair Shops',
          value: 112
        },
        {
          label: 'Eleclionics Stores',
          value: 113
        },
        {
          label: 'Elementary, Secondary Schools',
          value: 114
        },
        {
          label: 'Employment/Temp Agencies',
          value: 115
        },
        {
          label: 'Equipment Rental',
          value: 116
        },
        {
          label: 'Exterminating Services',
          value: 117
        },
        {
          label: 'Family Clothing Stores',
          value: 118
        },
        {
          label: 'Fast Food Restaurants',
          value: 119
        },
        {
          label: 'Financial Institutions',
          value: 120
        },
        {
          label: 'Fines - Government Adminisliative Entities',
          value: 121
        },
        {
          label: 'Fireplace, Fireplace Screens, and Accessories Stores',
          value: 122
        },
        {
          label: 'Floor Covering Stores',
          value: 123
        },
        {
          label: 'Florists',
          value: 124
        },
        {
          label: 'Florists Supplies, Nursery Stock, and Flowers',
          value: 125
        },
        {
          label: 'Freezer and Locker Meat Provisioners',
          value: 126
        },
        {
          label: 'Fuel Dealers (Non Automotive)',
          value: 127
        },
        {
          label: 'Funeral Services, Crematories',
          value: 128
        },
        {
          label: 'Furniture Repair, Refinishing',
          value: 129
        },
        {
          label: 'Furniture, Home Furnishings, and Equipment Stores, Except Appliances',
          value: 130
        },
        {
          label: 'Furriers and Fur Shops',
          value: 131
        },
        {
          label: 'General Services',
          value: 132
        },
        {
          label: 'Gift, Card, Novelty, and Souvenir Shops',
          value: 133
        },
        {
          label: 'Glass, Paint, and Wallpaper Stores',
          value: 134
        },
        {
          label: 'Glassware, Crystal Stores',
          value: 135
        },
        {
          label: 'Golf Courses - Public',
          value: 136
        },
        {
          label: 'Government Services (Not Elsewhere Classified)',
          value: 137
        },
        {
          label: 'Grocery Stores, Supermarkets',
          value: 138
        },
        {
          label: 'Hardware Stores',
          value: 139
        },
        {
          label: 'Hardware, Equipment, and Supplies',
          value: 140
        },
        {
          label: 'Health and Beauty Spas',
          value: 141
        },
        {
          label: 'Hearing Aids Sales and Supplies',
          value: 142
        },
        {
          label: 'Heating, Plumbing, A/C',
          value: 143
        },
        {
          label: 'Hobby, Toy, and Game Shops',
          value: 144
        },
        {
          label: 'Home Supply Warehouse Stores',
          value: 145
        },
        {
          label: 'Hospitals',
          value: 146
        },
        {
          label: 'Hotels, Motels, and Resorts',
          value: 147
        },
        {
          label: 'Household Appliance Stores',
          value: 148
        },
        {
          label: 'Indusliial Supplies (Not Elsewhere Classified)',
          value: 149
        },
        {
          label: 'Information Reliieval Services',
          value: 150
        },
        {
          label: 'Insurance - Default',
          value: 151
        },
        {
          label: 'Insurance Underwriting, Premiums',
          value: 152
        },
        {
          label: 'Inlia-Company Purchases',
          value: 153
        },
        {
          label: 'Jewelry Stores, Watches, Clocks, and Silverware Stores',
          value: 154
        },
        {
          label: 'Landscaping Services',
          value: 155
        },
        {
          label: 'Laundries',
          value: 156
        },
        {
          label: 'Laundry, Cleaning Services',
          value: 157
        },
        {
          label: 'Legal Services, Attorneys',
          value: 158
        },
        {
          label: 'Luggage and Leather Goods Stores',
          value: 159
        },
        {
          label: 'Lumber, Building Materials Stores',
          value: 160
        },
        {
          label: 'Manual Cash Disburse',
          value: 161
        },
        {
          label: 'Marinas, Service and Supplies',
          value: 162
        },
        {
          label: 'Masonry, Stonework, and Plaster',
          value: 163
        },
        {
          label: 'Massage Parlors',
          value: 164
        },
        {
          label: 'Medical Services',
          value: 165
        },
        {
          label: 'Medical and Dental Labs',
          value: 166
        },
        {
          label: 'Medical, Dental, Ophthalmic, and Hospital Equipment and Supplies',
          value: 167
        },
        {
          label: 'Membership Organizations',
          value: 168
        },
        {
          label: 'Mens and Boys Clothing and Accessories Stores',
          value: 169
        },
        {
          label: 'Mens, Womens Clothing Stores',
          value: 170
        },
        {
          label: 'Metal Service Centers',
          value: 171
        },
        {
          label: 'Miscellaneous Apparel and Accessory Shops',
          value: 172
        },
        {
          label: 'Miscellaneous Auto Dealers',
          value: 173
        },
        {
          label: 'Miscellaneous Business Services',
          value: 174
        },
        {
          label: 'Miscellaneous Food Stores - Convenience Stores and Specialty Markets',
          value: 175
        },
        {
          label: 'Miscellaneous General Merchandise',
          value: 176
        },
        {
          label: 'Miscellaneous General Services',
          value: 177
        },
        {
          label: 'Miscellaneous Home Furnishing Specialty Stores',
          value: 178
        },
        {
          label: 'Miscellaneous Publishing and Printing',
          value: 179
        },
        {
          label: 'Miscellaneous Recreation Services',
          value: 180
        },
        {
          label: 'Miscellaneous Repair Shops',
          value: 181
        },
        {
          label: 'Miscellaneous Specialty Retail',
          value: 182
        },
        {
          label: 'Mobile Home Dealers',
          value: 183
        },
        {
          label: 'Motion Picture Theaters',
          value: 184
        },
        {
          label: 'Motor Freight Carriers and liucking - Local and Long Distance, Moving and Storage Companies, and Local Delivery\n          Services',
          value: 185
        },
        {
          label: 'Motor Homes Dealers',
          value: 186
        },
        {
          label: 'Motor Vehicle Supplies and New Parts',
          value: 187
        },
        {
          label: 'Motorcycle Shops and Dealers',
          value: 188
        },
        {
          label: 'Motorcycle Shops, Dealers',
          value: 189
        },
        {
          label: 'Music Stores-Musical Insliuments, Pianos, and Sheet Music',
          value: 190
        },
        {
          label: 'News Dealers and Newsstands',
          value: 191
        },
        {
          label: 'Non-FI, Money Orders',
          value: 192
        },
        {
          label: 'Non-FI, Stored Value Card Purchase/Load',
          value: 193
        },
        {
          label: 'Nondurable Goods (Not Elsewhere Classified)',
          value: 194
        },
        {
          label: 'Nurseries, Lawn and Garden Supply Stores',
          value: 195
        },
        {
          label: 'Nursing/Personal Care',
          value: 196
        },
        {
          label: 'Office and Commercial Furniture',
          value: 197
        },
        {
          label: 'Opticians, Eyeglasses',
          value: 198
        },
        {
          label: 'Optomeliists, Ophthalmologist',
          value: 199
        },
        {
          label: 'Orthopedic Goods - Prosthetic Devices',
          value: 200
        },
        {
          label: 'Osteopaths',
          value: 201
        },
        {
          label: 'Package Stores-Beer, Wine, and Liquor',
          value: 202
        },
        {
          label: 'Paints, Varnishes, and Supplies',
          value: 203
        },
        {
          label: 'Parking Lots, Garages',
          value: 204
        },
        {
          label: 'Passenger Railways',
          value: 205
        },
        {
          label: 'Pawn Shops',
          value: 206
        },
        {
          label: 'Pet Shops, Pet Food, and Supplies',
          value: 207
        },
        {
          label: 'Pelioleum and Pelioleum Products',
          value: 208
        },
        {
          label: 'Photo Developing',
          value: 209
        },
        {
          label: 'Photographic Studios',
          value: 210
        },
        {
          label: 'Photographic, Photocopy, Microfilm Equipment, and Supplies',
          value: 211
        },
        {
          label: 'Picture/Video Production',
          value: 212
        },
        {
          label: 'Piece Goods, Notions, and Other Dry Goods',
          value: 213
        },
        {
          label: 'Plumbing, Heating Equipment, and Supplies',
          value: 214
        },
        {
          label: 'Political Organizations',
          value: 215
        },
        {
          label: 'Postal Services - Government Only',
          value: 216
        },
        {
          label: 'Precious Stones and Metals, Watches and Jewelry',
          value: 217
        },
        {
          label: 'Professional Services',
          value: 218
        },
        {
          label: 'Public Warehousing and Storage - Farm Products, Refrigerated Goods, Household Goods, and Storage',
          value: 219
        },
        {
          label: 'Quick Copy, Repro, and Blueprint',
          value: 220
        },
        {
          label: 'Railroads',
          value: 221
        },
        {
          label: 'Real Estate Agents and Managers - Rentals',
          value: 222
        },
        {
          label: 'Record Stores',
          value: 223
        },
        {
          label: 'Recreational Vehicle Rentals',
          value: 224
        },
        {
          label: 'Religious Goods Stores',
          value: 225
        },
        {
          label: 'Religious Organizations',
          value: 226
        },
        {
          label: 'Roofing/Siding, Sheet Metal',
          value: 227
        },
        {
          label: 'Secretarial Support Services',
          value: 228
        },
        {
          label: 'Security Brokers/Dealers',
          value: 229
        },
        {
          label: 'Service Stations',
          value: 230
        },
        {
          label: 'Sewing, Needlework, Fabric, and Piece Goods Stores',
          value: 231
        },
        {
          label: 'Shoe Repair/Hat Cleaning',
          value: 232
        },
        {
          label: 'Shoe Stores',
          value: 233
        },
        {
          label: 'Small Appliance Repair',
          value: 234
        },
        {
          label: 'Snowmobile Dealers',
          value: 235
        },
        {
          label: 'Special liade Services',
          value: 236
        },
        {
          label: 'Specialty Cleaning',
          value: 237
        },
        {
          label: 'Sporting Goods Stores',
          value: 238
        },
        {
          label: 'Sporting/Recreation Camps',
          value: 239
        },
        {
          label: 'Sports Clubs/Fields',
          value: 240
        },
        {
          label: 'Sports and Riding Apparel Stores',
          value: 241
        },
        {
          label: 'Stamp and Coin Stores',
          value: 242
        },
        {
          label: 'Stationary, Office Supplies, Printing and Writing Paper',
          value: 243
        },
        {
          label: 'Stationery Stores, Office, and School Supply Stores',
          value: 244
        },
        {
          label: 'Swimming Pools Sales',
          value: 245
        },
        {
          label: 'TUI liavel - Germany',
          value: 246
        },
        {
          label: 'Tailors, Alterations',
          value: 247
        },
        {
          label: 'Tax Payments - Government Agencies',
          value: 248
        },
        {
          label: 'Tax Preparation Services',
          value: 249
        },
        {
          label: 'Taxicabs/Limousines',
          value: 250
        },
        {
          label: 'Telecommunication Equipment and Telephone Sales',
          value: 251
        },
        {
          label: 'Telecommunication Services',
          value: 252
        },
        {
          label: 'Telegraph Services',
          value: 253
        },
        {
          label: 'Tent and Awning Shops',
          value: 254
        },
        {
          label: 'Testing Laboratories',
          value: 255
        },
        {
          label: 'Thealiical Ticket Agencies',
          value: 256
        },
        {
          label: 'Timeshares',
          value: 257
        },
        {
          label: 'Tire Relieading and Repair',
          value: 258
        },
        {
          label: 'Tolls/Bridge Fees',
          value: 259
        },
        {
          label: 'Tourist Atliactions and Exhibits',
          value: 260
        },
        {
          label: 'Towing Services',
          value: 261
        },
        {
          label: 'liailer Parks, Campgrounds',
          value: 262
        },
        {
          label: 'liansportation Services (Not Elsewhere Classified)',
          value: 263
        },
        {
          label: 'liavel Agencies, Tour Operators',
          value: 264
        },
        {
          label: 'liuck StopIteration',
          value: 265
        },
        {
          label: 'liuck/Utility liailer Rentals',
          value: 266
        },
        {
          label: 'Typesetting, Plate Making, and Related Services',
          value: 267
        },
        {
          label: 'Typewriter Stores',
          value: 268
        },
        {
          label: 'U.S. Federal Government Agencies or Departments',
          value: 269
        },
        {
          label: 'Uniforms, Commercial Clothing',
          value: 270
        },
        {
          label: 'Used Merchandise and Secondhand Stores',
          value: 271
        },
        {
          label: 'Utilities',
          value: 272
        },
        {
          label: 'Variety Stores',
          value: 273
        },
        {
          label: 'Veterinary Services',
          value: 274
        },
        {
          label: 'Video Amusement Game Supplies',
          value: 275
        },
        {
          label: 'Video Game Arcades',
          value: 276
        },
        {
          label: 'Video Tape Rental Stores',
          value: 277
        },
        {
          label: 'Vocational/liade Schools',
          value: 278
        },
        {
          label: 'Watch/Jewelry Repair',
          value: 279
        },
        {
          label: 'Welding Repair',
          value: 280
        },
        {
          label: 'Wholesale Clubs',
          value: 281
        },
        {
          label: 'Wig and Toupee Stores',
          value: 282
        },
        {
          label: 'Wires, Money Orders',
          value: 283
        },
        {
          label: 'Womens Accessory and Specialty Shops',
          value: 284
        },
        {
          label: 'Womens Ready-To-Wear Stores',
          value: 285
        },
        {
          label: 'Wrecking and Salvage Yards',
          value: 286
        }
      ]
    }
  },
  watch: {
    selected () {
      this.changed(this.selected)
    }
  },
  computed: {
    industry_options () {
      const result = [
        {
          label: 'Please select',
          value: ''
        }
      ]
      Object.keys(this.industryData).map(key => {
        result.push({
          label: this.industryData[key],
          value: key
        })
      })
      return result
    }
  },
  methods: {
    search_method () {
      const result = []
      this.$refs.list.children.map(child => {
        if (child.children[0].outerHTML.includes(this.search)) {
          result.push(child)
        }
      })

      return result
    },
    selectItem (item) {
      this.selected = item
      this.toggle = false
    }
  }
}
</script>

<style lang="scss">
.industry {
  /*the container must be positioned relative:*/
  position: relative;
  display: inline-block;
  input {
    margin-bottom: 0 !important;
  }

  .vs__actions {
    align-items: baseline;
  }

  .vs__dropdown-toggle {
    border: none;
  }

  .vs__selected-options {
    max-width: 100%;
  }

  .vs__selected {
    white-space: nowrap;
    max-width: 100%;
    overflow-y: unset;
    overflow-x: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  /*&.al-input .v-select{
    overflow-x: scroll;
    overflow-y: hidden;

    span {
      white-space: nowrap;
    }
    code {
      display: none;
    }
  }
*/
  .autocomplete-items {
    position: absolute;
    border: 1px solid #d4d4d4;
    border-bottom: none;
    border-top: none;
    z-index: 99;
    /*position the autocomplete items to be the same width as the container:*/
    top: 15px;
    left: 0;
    right: 0;
    background: white;
    max-height: 400px;
    overflow-y: scroll;
    box-shadow: 0px 0px 5px 5px rgba(0,0,0,.1);
    border-radius: 5px;
  }
  .autocomplete-items li {
    padding: 15px 20px;
    cursor: pointer;
    background-color: #fff;
    border-bottom: 1px solid #c3c3c3;
    word-wrap: break-word;
    min-height: 50px;

  }
  .autocomplete-items li:hover {
    /*when hovering an item:*/
    background-color: #e9e9e9;
  }
  .autocomplete-active {
    /*when navigating through the items using the arrow keys:*/
    background-color: DodgerBlue !important;
    color: #ffffff;
  }
}
</style>
